import Vue from 'vue';
import Vuex from 'vuex';

export function createStore(options) {
  Vue.use(Vuex);
  const store = new Vuex.Store(options);
  return store;
}

export function assignModule(object, sources) {
  const keys = Object.keys(sources);
  keys.forEach((key) => {
    object[key] = Object.assign(object[key] || {}, sources[key]);
  });
  return object;
}
